module.exports = __webpack_public_path__ + "static/media/fiscal.21e1942b.csv";